/**
 * AvgServicesPerMemberChart — NOT_CONNECTED
 *
 * Services-per-member data requires Core Banking integration.
 * Renders DataSourceNotConnected placeholder.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const AvgServicesPerMemberChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.core_banking}
      metricName="Avg Services per Member"
    />
  );
};

export default AvgServicesPerMemberChart;